const testimonials = [
  {
    name: "David R.",
    location: "Windermere, FL",
    rating: 5,
    text: "I live in Isleworth and had a board meeting in London scheduled with two weeks' notice. I pulled my passport and realized it had expired three months earlier. Fast Passport Center processed my renewal in five business days. I made the flight to Heathrow, attended the meeting, and closed the deal. Their team understood the urgency of executive business travel in a way that gave me complete confidence.",
    service: "Passport Renewal",
  },
  {
    name: "Jennifer M.",
    location: "Windermere, FL",
    rating: 5,
    text: "We booked a Disney Cruise to the Bahamas for spring break — our family of five, including three children. I checked everyone's passport two weeks before sailing and discovered two of our kids' passports had expired. I panicked. Fast Passport Center walked me through the child passport process, I shipped everything overnight from the UPS Store in Ocoee, and all three passports arrived four days later. We made the cruise with a day to spare. Absolutely saved our vacation.",
    service: "Child Passport",
  },
  {
    name: "Dr. Carlos A.",
    location: "Windermere, FL",
    rating: 5,
    text: "I am a physician at the Lake Nona VA Medical Center and was invited to present at a cardiology conference in Frankfurt with ten days' notice. My passport was valid but had only four months remaining — Germany requires six months. Fast Passport Center handled my expedited renewal and I had my new passport in hand five days before my flight. Their document review caught a photo issue I would have missed. Outstanding service.",
    service: "Expedited Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function WindermereTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Windermere Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Windermere executives, Disney-area professionals, and lakefront families who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}